import { once as once$1 } from '../../function/once.mjs';

function once(func) {
    return once$1(func);
}

export { once };
